import React from "react";

function FooterCard2() {
  return (
    <>
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-4 py-5 gap-10 px-5 lg:px-12 ">
          <div className="col-span-1">
            <h1 className="text-[18px] font-[700] text-[#fff] pb-2">AboutUs</h1>
            <p className="text-[15px] text-[#c1c7ce] leading-[23px] py-3">
              We are proud to offer a wide range of comprehensive services to
              meet the needs of adults, seniors, and pediatric patients. Our
              team of professional caregivers specialize in providing
              personalized medical care, rehabilitative therapy and companion
              assistance.
            </p>
            <div className="bg-[#a175aa] hover:bg-[#9A65A5] cursor-pointer text-white text-[14.5px] font-[500] p-3 w-40  text-center rounded-full my-2">
              See All Services
            </div>
          </div>
          <div className="col-span-1">
            <h1 className="text-[18px] font-[700] text-[#fff] pb-5">
              Extra Navigation
            </h1>
            <div className="flex justify-start align-middle items-center cursor-pointer gap-1 fill-[#c1c7ce7f] hover:fill-white text-[#c1c7ce] hover:text-white ">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  className="   "
                  viewBox="0 0 24 24"
                >
                  <path d="M7.293 4.707L14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707z"></path>
                </svg>
              </div>
              <div className="text-[14px] font-[500]  my-0.5">
                Find out More
              </div>
            </div>
            <div className="flex justify-start align-middle items-center cursor-pointer gap-1 fill-[#c1c7ce7f] hover:fill-white text-[#c1c7ce] hover:text-white ">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  className="   "
                  viewBox="0 0 24 24"
                >
                  <path d="M7.293 4.707L14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707z"></path>
                </svg>
              </div>
              <div className="text-[14px] font-[500]  my-0.5">
                Find out More
              </div>
            </div>
            <div className="flex justify-start align-middle items-center cursor-pointer gap-1 fill-[#c1c7ce7f] hover:fill-white text-[#c1c7ce] hover:text-white ">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  className="   "
                  viewBox="0 0 24 24"
                >
                  <path d="M7.293 4.707L14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707z"></path>
                </svg>
              </div>
              <div className="text-[14px] font-[500]  my-0.5">
                Find out More
              </div>
            </div>
          </div>
          <div className="col-span-1">
            <h1 className="text-[18px] font-[700] text-[#fff] pb-5">
              Our Services
            </h1>
            <div className="flex justify-start align-middle items-center cursor-pointer gap-1 fill-[#c1c7ce7f] hover:fill-white text-[#c1c7ce] hover:text-white ">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  className="   "
                  viewBox="0 0 24 24"
                >
                  <path d="M7.293 4.707L14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707z"></path>
                </svg>
              </div>
              <div className="text-[14px] font-[500]  my-0.5">
                Find out More
              </div>
            </div>
            <div className="flex justify-start align-middle items-center cursor-pointer gap-1 fill-[#c1c7ce7f] hover:fill-white text-[#c1c7ce] hover:text-white ">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  className="   "
                  viewBox="0 0 24 24"
                >
                  <path d="M7.293 4.707L14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707z"></path>
                </svg>
              </div>
              <div className="text-[14px] font-[500]  my-0.5">
                Find out More
              </div>
            </div>
            <div className="flex justify-start align-middle items-center cursor-pointer gap-1 fill-[#c1c7ce7f] hover:fill-white text-[#c1c7ce] hover:text-white ">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  className="   "
                  viewBox="0 0 24 24"
                >
                  <path d="M7.293 4.707L14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707z"></path>
                </svg>
              </div>
              <div className="text-[14px] font-[500]  my-0.5">
                Find out More
              </div>
            </div>
          </div>
          <div className="col-span-1">
            <h1 className="text-[18px] font-[700] text-[#fff] pb-5">
              Opening Hours
            </h1>
            <div className="text-[#c1c7ce] flex justify-between align-middle items-center text-[14px] font-[500] ">
              <div>Monday</div>
              <div>07:00-17:00</div>
            </div>
            <div className="border-b-2 border-[#c1c7ce2a] my-1.5"></div>
            <div className="text-[#c1c7ce] flex justify-between align-middle items-center text-[14px] font-[500] ">
              <div>Tuesday</div>
              <div>07:00-17:00</div>
            </div>
            <div className="border-b-2 border-[#c1c7ce2a] my-1.5"></div>
            <div className="text-[#c1c7ce] flex justify-between align-middle items-center text-[14px] font-[500] ">
              <div>Wednesday</div>
              <div>07:00-17:00</div>
            </div>
            <div className="border-b-2 border-[#c1c7ce2a] my-1.5"></div>
            <div className="text-[#c1c7ce] flex justify-between align-middle items-center text-[14px] font-[500] ">
              <div>Thursday</div>
              <div>07:00-17:00</div>
            </div>
            <div className="border-b-2 border-[#c1c7ce2a] my-1.5"></div>
            <div className="text-[#c1c7ce] flex justify-between align-middle items-center text-[14px] font-[500] ">
              <div>Friday</div>
              <div>07:00-17:00</div>
            </div>
            <div className="border-b-2 border-[#c1c7ce2a] my-1.5"></div>
            <div className="text-[#c1c7ce] flex justify-between align-middle items-center text-[14px] font-[500] ">
              <div>Saturday</div>
              <div>07:00-15:00</div>
            </div>
            <div className="border-b-2 border-[#c1c7ce2a] my-1.5"></div>
            <div className="text-[#c1c7ce] flex justify-between align-middle items-center text-[14px] font-[500] ">
              <div>Sunday</div>
              <div>Closed</div>
            </div>
            <div className="border-b-2 border-[#c1c7ce2a] my-1.5"></div>
          </div>
        </div>
      </div>
 
    </>
  );
}

export default FooterCard2;
